import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SyncService } from 'src/app/core/services';
import IAttributesStatisticFlags = ZoneIQCalibration.IAttributesStatisticFlags;

@Component({
    standalone: false,
    selector: 'ziq-calibration-set-attributes-icons',
    templateUrl: './calibration-set-attributes-icons.component.html',
    styleUrls: ['./calibration-set-attributes-icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalibrationSetAttributesIconsComponent implements OnInit, OnDestroy {
    subscription = new Subscription();

    @Input()
    attributesFlags: IAttributesStatisticFlags;

    constructor(private readonly syncService: SyncService, private readonly cd: ChangeDetectorRef) {}

    ngOnInit() {
        this.subscription.add(
            this.syncService.changeDetection.subscribe(() => {
                this.triggerChangeDetection();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private triggerChangeDetection() {
        if (!this.cd) {
            return;
        }
        this.cd.detectChanges();
    }
}
